import React, { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { EPeriodTableCellEnum } from './period-table.enum';
import { STableActiveCell, STableCellPlaceholder } from './period-table.styles';

type TProps = {
  children: React.ReactNode;
  type: EPeriodTableCellEnum;
};

const PeriodTableCellComponent = ({ children, type }: TProps): ReactElement => (
  <STableActiveCell>
    {{
      [EPeriodTableCellEnum.Max]: children ?? (<STableCellPlaceholder>
        <Trans i18nKey="limits.standardLimits.table.period.column.cell.placeholder.max" />
      </STableCellPlaceholder>),
      [EPeriodTableCellEnum.CustomDays]: children ?? (<STableCellPlaceholder>
        <div><Trans i18nKey="limits.standardLimits.table.period.column.cell.placeholder.days" /></div>
        <div><Trans i18nKey="limits.standardLimits.table.period.column.cell.placeholder.max" /></div>
      </STableCellPlaceholder>),
    }[type as string]}
  </STableActiveCell>
);

export default PeriodTableCellComponent;
